import React, { useState, useContext } from "react";

import Header from "../../components/template/estimate/Header";
import StorageHeroImage from "../../assets/images/estimate/storage_hero_image.png";
import GetEstimate from "../../components/storage_service/GetEstimate";
import MovePlannerContext from "../../context/move_planner/movePlanner";

import ProgressBar from "../../components/storage_service/ProgressBar";

import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  thunkSubmitMoveInfoForm,
  updateFormSubmitStatus,
} from "../../redux/reducers/storage_moveinfo/moveInfoReducer";
import { useEffect } from "react";
import LoginModal from "../../components/inventory/Modal/LoginModal";
export function StorageMoveInfo() {
  const context = useContext(MovePlannerContext);
  const { handleSubmit } =
    context.estimateForm.useStorageMoveInfoForm;

  const dispatch = useDispatch();
  const history = useHistory();
  const moveInfoState = useSelector((state) => state.moveInfo);
  //state
  const [moveType, setMoveType] = useState(moveInfoState.moveType);
  const [isCityListLoading, setIsCityListFetching] = useState(true);
  const [cityList, setCityList] = useState(null);
  const [hasError, setHasError] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [moveInfoData, setMoveInfoData] = useState(null);
  const userInfo = useSelector((state) => state.userInfo);
  // const [utmUrl, setUtmUrl] = useState(null);

  const onSubmit = async (data, event) => {
    if (data.floor_no === undefined) {
      data["floor_no"] = 0;
    }
    //async validation
    dispatch(updateFormSubmitStatus({ status: true }));
    // const fromAddress =
    //   data["city_type"] === "Within City"
    //     ? data["from_area_within"]
    //     : data["from_area_between"];
    // const toAddress =
    //   data["city_type"] === "Within City"
    //     ? data["to_area_within"]
    //     : data["to_area_between"];
    // //get geocode of from and to
    // const fromGeoCode = await getGeoCode(fromAddress);
    // const toGeoCode = await getGeoCode(toAddress);

    // const checkResult = compareGeoCodes(fromGeoCode, toGeoCode);
    // if (checkResult === false) {
    //   if (data["city_type"] === "Within City") {
    //     setError("from_area_within", { type: "isFromAndToSame" });
    //     setError("to_area_within", { type: "isFromAndToSame" });
    //   } else {
    //     // set for between
    //     setError("from_area_between", { type: "isFromAndToSame" });
    //     setError("to_area_between", { type: "isFromAndToSame" });
    //   }
    //   dispatch(updateFormSubmitStatus({ status: false }));
    //   return;
    // }
    // if (data["city_type"] === "Within City") {
    //   const selectedCityBounds = cityList.filter(
    //     (cityObj) => cityObj.city === data["select_city"]
    //   );
    //   const checkFromAddress = checkWithinCityBounds(
    //     selectedCityBounds[0].geocode.bounds,
    //     fromGeoCode
    //   );
    //   const checkToAddress = checkWithinCityBounds(
    //     selectedCityBounds[0].geocode.bounds,
    //     toGeoCode
    //   );
    //   if (checkFromAddress === false || checkToAddress === false) {
    //     if (checkFromAddress === false) {
    //       setError("from_area_within", { type: "isWithinCityBounds" });
    //     }
    //     if (checkToAddress === false) {
    //       setError("to_area_within", { type: "isWithinCityBounds" });
    //     }
    //     dispatch(updateFormSubmitStatus({ status: false }));
    //     return;
    //   }
    // }
    let gotoPage = undefined;
    if (event !== undefined) {
      gotoPage = event.gotoPage;
    }
    const payload = { data, history, gotoPage: gotoPage };
    if (userInfo.loggedIn === false) {
      //check if user is already logged in
      setLoginModal(true);
      setMoveInfoData(payload);
      return;
    } else {
      dispatch(thunkSubmitMoveInfoForm(payload));
      return;
    }
  };



  const utmUrlhandler = (url) => {
    const urlPathIndex = url.indexOf('urlpath=');
    if (urlPathIndex !== -1) {
      const substring = url.slice(urlPathIndex + 'urlpath='.length);
      // setUtmUrl(substring)
      sessionStorage.setItem("urlpath", JSON.stringify(substring));
      // alert(substring)
    }
  };

  useEffect(() => {
    utmUrlhandler(window.location.href.trim());
  }, []);


  useEffect(() => {
    try {
      if (cityList === null) {
        return;
      }
      let param = new URLSearchParams(window.location.search);

      if (
        param.get("select_city") !== null &&
        param.get("pickup_address") !== null &&
        param.get("service_lift_available") !== null &&
        param.get("floor_no") !== null &&
        param.get("days_of_storage") !== null &&
        param.get("pick_up_date") !== null
      ) {
        // setIsLoading(true);
        const select_city = param.get("select_city");
        const pickup_address = param.get("pickup_address");
        const service_lift_available = param.get("service_lift_available");
        const floor_no = param.get("floor_no");
        const days_of_storage = param.get("days_of_storage");
        const pick_up_date = param.get("pick_up_date");
        const data = {
          pickup_date: new Date(pick_up_date),
          select_city: select_city,
          pickup_address: pickup_address,
          elevator_availability: service_lift_available,
          floor_no: floor_no,
          days_of_storage: days_of_storage,
        };
        onSubmit(data);
      }
    } catch (e) {
      console.error(e);
    }
    // eslint-disable-next-line
  }, [cityList]);
  const JSX = (
    <React.Fragment>
      <Header
        currentPage="storageMoveDetails"
        referenceToSubmit={(params) => {
          handleSubmit(onSubmit)(params);
        }}
        serviceType="storage"
      />
      <main className="get-estimate">
        {/* Mobile view progress bar */}
        <div className="container">
          <section className="progress-bar-section">
            <div className="row align-items-center justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-9">
                <ProgressBar
                  currentPage="storageMoveDetails"
                  referenceToSubmit={(params) => {
                    handleSubmit(onSubmit)(params);
                  }}
                  serviceType="storage"
                />
              </div>
            </div>
          </section>
        </div>
        <section className="container section-1 move-details-section storage-movedetails-section">
          <h1 className="title">Boxigo Storage Service</h1>
          <p className="sub-title">
            A one stop solution for all your storage requirements.
          </p>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-7">
              <div className="row align-items-center justify-content-center">
                <div className="col-12">
                  <div className="img-container">
                    <img src={StorageHeroImage} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <GetEstimate
              state={{
                moveType: moveType,
                setMoveType: setMoveType,
                isCityListLoading: isCityListLoading,
                setIsCityListFetching: setIsCityListFetching,
                cityList: cityList,
                setCityList: setCityList,
                hasError: hasError,
                setHasError: setHasError,
                onSubmit: onSubmit,
              }}
            />
            {/* <MoveDetailsHeading /> */}
          </div>
        </section>
        {loginModal === true && moveInfoData !== null && (
          <LoginModal
            isOpen={loginModal}
            isSkipInventory={true}
            additionalInfo={""}
            toggle={() => {
              setLoginModal(false);
              setMoveInfoData(null);
              dispatch(updateFormSubmitStatus({ status: false }));
            }}
            moveInfoData={moveInfoData}
            serviceType={"storage"}
          />
        )}
      </main>
    </React.Fragment>
  );
  return JSX;
}
